import { render, staticRenderFns } from "./LevInput.vue?vue&type=template&id=2644be91&scoped=true"
import script from "./LevInput.vue?vue&type=script&lang=js"
export * from "./LevInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644be91",
  null
  
)

export default component.exports